/**
 * hashes selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface State {
    hashes: {
        [string]: string
    };
}

const selectHashes = (state: State) => state.hashes;

const makeSelectHash = (namespace: string) =>
    createDeepEqualSelector(
        selectHashes,
        hashesState => hashesState && hashesState[namespace]
    );

export { selectHashes, makeSelectHash };
